// extracted by css-extract-rspack-plugin
export default {"formFeedback":"formFeedback-2Ki_g","feedbackIcon":"feedbackIcon-V3OCP"};